define('dcf-button-toggle',["exports", "./dcf-utility"], function (_exports, _dcfUtility) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.DCFToggleButton = void 0;

  function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

  function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

  function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

  function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

  function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

  var DCFToggleButton = /*#__PURE__*/function () {
    // Set up the button
    function DCFToggleButton(toggleButtons) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, DCFToggleButton);

      // Create the events for toggling the button and element
      this.toggleButtonOn = new Event(DCFToggleButton.events('toggleButtonOn'));
      this.toggleButtonOff = new Event(DCFToggleButton.events('toggleButtonOff'));
      this.toggleElementOn = new Event(DCFToggleButton.events('toggleElementOn'));
      this.toggleElementOff = new Event(DCFToggleButton.events('toggleElementOff')); // Copy the Keys without copying the references
      // Objects plus their properties and arrays are pass by reference

      this.toggleKeys = [];

      if (Array.isArray(options.toggleKeys)) {
        this.toggleKeys = _toConsumableArray(options.toggleKeys);
      } else if (options.toggleKeys !== null && options.toggleKeys !== undefined && options.toggleKeys !== '') {
        this.toggleKeys.push(options.toggleKeys);
      }

      this.onKeys = [];

      if (Array.isArray(options.onKeys)) {
        this.onKeys = _toConsumableArray(options.onKeys);
      } else if (options.onKeys !== null && options.onKeys !== undefined && options.onKeys !== '') {
        this.onKeys.push(options.onKeys);
      }

      this.offKeys = [];

      if (Array.isArray(options.offKeys)) {
        this.offKeys = _toConsumableArray(options.offKeys);
      } else if (options.offKeys !== null && options.offKeys !== undefined && options.offKeys !== '') {
        this.offKeys.push(options.offKeys);
      } // These keys will always work
      // Do not care about case due to the implementation of DCFUtility.keyEvents


      if (!this.toggleKeys.includes('space')) {
        this.toggleKeys.push('space');
      }

      if (!this.offKeys.includes('escape')) {
        this.offKeys.push('escape');
      } // Create a random ID for the button


      this.uuid = _dcfUtility.DCFUtility.uuidv4(); // Store the button inputted (always will be an array)

      this.toggleButtons = toggleButtons;

      if (NodeList.prototype.isPrototypeOf(this.toggleButtons)) {
        this.toggleButtons = Array.from(this.toggleButtons);
      } else if (!Array.isArray(this.toggleButtons)) {
        this.toggleButtons = [this.toggleButtons];
      }
    } // The names of the events to be used easily


    _createClass(DCFToggleButton, [{
      key: "initialize",
      value: // Initialize the buttons that were inputted in the constructor
      function initialize() {
        var _this = this;

        // loops through each one
        this.toggleButtons.forEach(function (toggleButton) {
          // Gets the info for the thing the button is toggling
          var toggleElementId = toggleButton.dataset.controls;
          var toggleElement = document.getElementById(toggleElementId);

          if (toggleElement === null) {
            throw new Error('Missing Toggle Element');
          } // Gets the info for setting up the button


          var toggleButtonIdPostfix = toggleButton.dataset.postfix;

          if (toggleButtonIdPostfix === undefined) {
            toggleButtonIdPostfix = '';
          }

          var toggleButtonStartExpanded = toggleButton.dataset.startExpanded;

          if (toggleButtonStartExpanded === undefined) {
            toggleButtonStartExpanded = 'false';
          } // if it does not have an ID set it to a random one


          if (toggleButton.id === '') {
            toggleButton.id = _this.uuid.concat('-button-', toggleButtonIdPostfix);
          } // set the attributes for the button


          toggleButton.setAttribute('aria-controls', toggleElementId); // set the attributes for the thing being toggled

          if (toggleElement.getAttribute('aria-labelledby') !== null && toggleElement.getAttribute('aria-labelledby') !== toggleButton.id) {
            throw new Error('Toggle Element Already Has Toggle Button');
          }

          toggleElement.setAttribute('aria-labelledby', toggleButton.id); // ToggleSwitched will set many of the other attributes and styles

          var expandedState = toggleButtonStartExpanded === 'true' ? 'open' : 'close';

          _this.toggleSwitched(toggleButton, toggleElement, expandedState); // set up the event listeners for the button and element


          _this.eventListeners(toggleButton, toggleElement);
        });
      } // sets up the event listeners for the button

    }, {
      key: "eventListeners",
      value: function eventListeners(toggleButton, toggleElement) {
        var _this2 = this;

        // Toggle the element when button is clicked
        toggleButton.addEventListener('click', function (clickEvent) {
          var switched = _this2.toggleSwitched(toggleButton, toggleElement);

          if (switched) {
            clickEvent.preventDefault();
          }
        }, false); // Show/hide element when the 'space' key is pressed
        // Hide element when the `escape` is pressed

        toggleButton.addEventListener('keydown', function (keydownEvent) {
          _this2.toggleKeys.forEach(function (key) {
            if (_dcfUtility.DCFUtility.isKeyEvent(keydownEvent, _dcfUtility.DCFUtility.keyEvents(key))) {
              var switched = _this2.toggleSwitched(toggleButton, toggleElement);

              if (switched) {
                keydownEvent.preventDefault();
              }
            }
          });

          _this2.onKeys.forEach(function (key) {
            if (_dcfUtility.DCFUtility.isKeyEvent(keydownEvent, _dcfUtility.DCFUtility.keyEvents(key))) {
              var switched = _this2.toggleSwitched(toggleButton, toggleElement, 'open');

              if (switched) {
                keydownEvent.preventDefault();
              }
            }
          });

          _this2.offKeys.forEach(function (key) {
            if (_dcfUtility.DCFUtility.isKeyEvent(keydownEvent, _dcfUtility.DCFUtility.keyEvents(key))) {
              var switched = _this2.toggleSwitched(toggleButton, toggleElement, 'close');

              if (switched) {
                keydownEvent.preventDefault();
              }
            }
          });
        }, false);
        toggleButton.addEventListener(DCFToggleButton.events('commandOpen'), function () {
          _this2.toggleSwitched(toggleButton, toggleElement, 'open');
        });
        toggleButton.addEventListener(DCFToggleButton.events('commandClose'), function () {
          _this2.toggleSwitched(toggleButton, toggleElement, 'close');
        });
        toggleButton.addEventListener(DCFToggleButton.events('commandToggle'), function () {
          _this2.toggleSwitched(toggleButton, toggleElement);
        });
        toggleElement.addEventListener(DCFToggleButton.events('commandOpen'), function () {
          _this2.toggleSwitched(toggleButton, toggleElement, 'open');
        });
        toggleElement.addEventListener(DCFToggleButton.events('commandClose'), function () {
          _this2.toggleSwitched(toggleButton, toggleElement, 'close');
        });
        toggleElement.addEventListener(DCFToggleButton.events('commandToggle'), function () {
          _this2.toggleSwitched(toggleButton, toggleElement);
        });
      } // Handles the logic for the button
      // This will only call the animations

    }, {
      key: "toggleSwitched",
      value: function toggleSwitched(toggleButton, toggleElement) {
        var state = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
        // Gets the labels for the button
        var toggleButtonLabelOn = toggleButton.dataset.labelOn;
        var toggleButtonLabelOff = toggleButton.dataset.labelOff; // Toggled On

        if ((toggleButton.getAttribute('aria-expanded') === 'false' || toggleButton.getAttribute('aria-expanded') === null || toggleButton.getAttribute('aria-expanded') === '') && (state === 'open' || state === '')) {
          toggleButton.setAttribute('aria-expanded', 'true');

          if ('labelOff' in toggleButton.dataset) {
            toggleButton.setAttribute('aria-label', toggleButtonLabelOff);
          }

          toggleButton.dispatchEvent(this.toggleButtonOn);
          toggleElement.setAttribute('aria-hidden', 'false');
          toggleElement.classList.remove('dcf-opacity-0', 'dcf-pointer-events-none');
          toggleElement.classList.add('dcf-opacity-100', 'dcf-pointer-events-auto'); // Make everything inside toggle element use old tab index and old disabled value if it had one

          toggleElement.querySelectorAll('*').forEach(function (elem) {
            if ('oldTabIndex' in elem.dataset && elem.dataset.oldTabIndex !== 'false') {
              elem.setAttribute('tabindex', elem.dataset.oldTabIndex);
            } else if ('oldTabIndex' in elem.dataset && elem.dataset.oldTabIndex === 'false') {
              elem.removeAttribute('tabindex');
            }

            delete elem.dataset.oldTabIndex;

            if ('oldDisabled' in elem.dataset && elem.dataset.oldDisabled === 'false') {
              elem.removeAttribute('disabled');
            }

            delete elem.dataset.oldDisabled;
          }); // Make toggle element use old tab index if it had one

          if (toggleElement.dataset.oldTabIndex && toggleElement.dataset.oldTabIndex !== 'false') {
            toggleElement.setAttribute('tabindex', '-1');
          } else {
            toggleElement.removeAttribute('tabindex');
          }

          delete toggleElement.dataset.oldTabIndex; // Make toggle element use disabled value if it had one

          if (toggleElement.dataset.oldDisabled && toggleElement.dataset.oldDisabled !== 'false') {
            toggleElement.disabled = true;
          } else {
            toggleElement.removeAttribute('disabled');
          }

          delete toggleElement.dataset.oldDisabled; // Dispatch event incase something else is using it

          toggleElement.dispatchEvent(this.toggleElementOn); // Focus on newly opened thing

          toggleElement.focus();
          return true; // Toggle Off
        } else if ((toggleButton.getAttribute('aria-expanded') === 'true' || toggleButton.getAttribute('aria-expanded') === null || toggleButton.getAttribute('aria-expanded') === '') && (state === 'close' || state === '')) {
          toggleButton.setAttribute('aria-expanded', 'false');

          if ('labelOn' in toggleButton.dataset) {
            toggleButton.setAttribute('aria-label', toggleButtonLabelOn);
          }

          toggleButton.dispatchEvent(this.toggleButtonOff);
          toggleElement.setAttribute('aria-hidden', 'true');
          toggleElement.classList.remove('dcf-opacity-100', 'dcf-pointer-events-auto');
          toggleElement.classList.add('dcf-pointer-events-none', 'dcf-opacity-0'); // Make everything inside toggle element not tabbable and disabled plus saving old values if it had one

          toggleElement.querySelectorAll('*').forEach(function (elem) {
            elem.dataset.oldTabIndex = elem.getAttribute('tabindex') || 'false';
            elem.dataset.oldDisabled = elem.disabled;
            elem.setAttribute('tabindex', '-1');
            elem.disabled = true;
          }); // Make toggle element not tabbable and disabled plus saving old values if it had one

          toggleElement.dataset.oldTabIndex = toggleElement.getAttribute('tabindex') || 'false';
          toggleElement.dataset.oldDisabled = toggleElement.disabled;
          toggleElement.setAttribute('tabindex', '-1');
          toggleElement.disabled = true; // Dispatch event incase something else is using it

          toggleElement.dispatchEvent(this.toggleElementOff);
          return true;
        }

        return false;
      }
    }], [{
      key: "events",
      value: function events(name) {
        var events = {
          toggleButtonOn: 'toggleButtonOn',
          toggleButtonOff: 'toggleButtonOff',
          toggleElementOn: 'toggleElementOn',
          toggleElementOff: 'toggleElementOff',
          commandClose: 'commandClose',
          commandOpen: 'commandOpen',
          commandToggle: 'commandToggle'
        };
        Object.freeze(events);
        return name in events ? events[name] : undefined;
      }
    }]);

    return DCFToggleButton;
  }();

  _exports.DCFToggleButton = DCFToggleButton;
});

